import { OfferMerchandiseTypeEnum } from './enums/offer-merchandise-type.enum';
import { OfferServiceTypeEnum } from './enums/offer-service-type.enum';

export class CardsTypeSelector {
  // Typologie de marchandise (offre)
  static readonly CONDITIONED = new CardsTypeSelector(
    'MODAL_NEW_OFFER.MERCHANDISE_TYPE.CONDITIONED.TITLE',
    'MODAL_NEW_OFFER.MERCHANDISE_TYPE.CONDITIONED.DESCRIPTION',
    OfferMerchandiseTypeEnum.CONDITIONED,
    false,
    false
  );
  static readonly UNCONDITIONED = new CardsTypeSelector(
    'MODAL_NEW_OFFER.MERCHANDISE_TYPE.UNCONDITIONED.TITLE',
    'MODAL_NEW_OFFER.MERCHANDISE_TYPE.UNCONDITIONED.DESCRIPTION',
    OfferMerchandiseTypeEnum.UNCONDITIONED,
    false,
    true
  );

  public static readonly OFFER_MARCHANDISE_TYPE = new Array<CardsTypeSelector>(CardsTypeSelector.CONDITIONED, CardsTypeSelector.UNCONDITIONED);

  // Typologie de service (offre)
  static readonly FTL = new CardsTypeSelector('MODAL_NEW_OFFER.SERVICE_TYPE.FTL.TITLE', 'MODAL_NEW_OFFER.SERVICE_TYPE.FTL.DESCRIPTION', OfferServiceTypeEnum.FTL, false, false);
  static readonly LTL = new CardsTypeSelector('MODAL_NEW_OFFER.SERVICE_TYPE.LTL.TITLE', 'MODAL_NEW_OFFER.SERVICE_TYPE.LTL.DESCRIPTION', OfferServiceTypeEnum.LTL, true, false);

  public static readonly SERVICE_TYPE = new Array<CardsTypeSelector>(CardsTypeSelector.LTL, CardsTypeSelector.FTL);

  private constructor(public titleKey: string, public descriptionKey: string, public value: any, public selected: boolean, public disabled: boolean) {}
}
